import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';
import { FONT_SIZE } from '../TextBox/constants';

const Quote = ({ children, options }: Props) => React.createElement(TextBox, { options, size: FONT_SIZE.MEDIUM, children: `« ${children} »` });

export default Quote;